import type Backbone from 'backbone';
import { ProductType } from '@ve/types/ProductType';
import type { IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue';
import { isTravelataOperatorId } from '@entities/operator';

const getProductModel = (tour: IBackboneProduct) => tour.get('product');
const getOperatorId = (tour: IBackboneProduct): number => getProductModel(tour)?.get('operator')?.id ?? 0;
const getPrice = (tour: IBackboneProduct): number => getProductModel(tour)?.get('price') ?? 0;
const getRoomKey = (tour: IBackboneProduct): string | number => {
    const room = getProductModel(tour)?.get('room');
    return room?.category ?? room?.name;
};

interface SupplierQtyParams {
    differentRoomsQty: number;
    roomsWithOtherSuppliersQty: number;
    differentSuppliersQty: number;
    suppliers: string;
    xtravelMinPrice: number | null;
    otherSuppliersMinPrice: number | null;
    otherSuppliersMinPriceSupplier: number | null;
}

export default (foundTours?: Backbone.Collection<IBackboneProduct> | null): SupplierQtyParams => {
    const products = (foundTours?.models ?? []).filter((tour) => tour.get('type') === ProductType.HotelOfferProduct);

    const differentRooms = new Set<string | number>();
    const roomsWithOtherSuppliers = new Set<string | number>();
    const differentSuppliers = new Set<number>();
    const supplierOffersCount: Record<string, number> = {};
    let xtravelMinPrice: number | null = null;
    let otherSuppliersMinPrice: number | null = null;
    let otherSuppliersMinPriceSupplier: number | null = null;

    products.forEach((tour) => {
        const operatorId = getOperatorId(tour);
        const roomKey = getRoomKey(tour);
        const price = getPrice(tour);

        differentRooms.add(roomKey);
        supplierOffersCount[operatorId] = (supplierOffersCount[operatorId] || 0) + 1;

        if (isTravelataOperatorId(operatorId)) {
            if (xtravelMinPrice === null || price < xtravelMinPrice) {
                xtravelMinPrice = price;
            }
            return;
        }

        roomsWithOtherSuppliers.add(roomKey);
        differentSuppliers.add(operatorId);
        if (otherSuppliersMinPrice === null || price < otherSuppliersMinPrice) {
            otherSuppliersMinPrice = price;
            otherSuppliersMinPriceSupplier = operatorId;
        }
    });

    return {
        differentRoomsQty: differentRooms.size,
        roomsWithOtherSuppliersQty: roomsWithOtherSuppliers.size,
        differentSuppliersQty: differentSuppliers.size,
        suppliers: JSON.stringify(supplierOffersCount),
        xtravelMinPrice,
        otherSuppliersMinPrice,
        otherSuppliersMinPriceSupplier,
    };
};
